module.exports = __webpack_public_path__ + "img/welcomes-minip.ad9b1cc8.png";